import { Box } from "@mui/material";
import { PULSE_DOT_SX } from "@/constants";

export function PulseDot() {
  return <Box sx={PULSE_DOT_SX} />;
}
